define('shared/initializer/form/adapters/mixins/FixOnSuccessfulUrl',[
    'shared/lib/RSVP',
    '../../constants',
    'shared/util/checkout/member'
], function(
    RSVP, 
    constants,
    memberUtil
){

    function Ctor(){}

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;

        if(memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve();
        }

        return RSVP.resolve()
        .then(function(){
            var $el = me.$form.find('input[name=' + constants.FIELD.OnSuccessUrl + ']');
            var anchor = document.createElement('a');
            var oldOnSuccessUrl = $el.val();
            anchor.href = oldOnSuccessUrl;
            $el.val(anchor.href);
            console.log('Updating OnSuccessUrl from:', oldOnSuccessUrl, ' to:', anchor.href);
        });
    };

    return Ctor;
});
